module.exports = __webpack_public_path__ + "static/media/grid_connection.c604559a.png";